import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { EmailTemplatesAutoReplyHttpClient } from '../auto-reply-http-client';
import { EmailTemplatesAssignedOffersActions } from './assigned-offers.store';

@Injectable({ providedIn: 'root' })
export class EmailTemplatesAssignedOffersEffects {
  public effects = createEffectFactory(EmailTemplatesAssignedOffersActions, this.actions$);

  public fetch$ = this.effects(EmailTemplatesAssignedOffersActions.fetch, ({ payload }) => {
    const { id, searchParams } = payload;
    return this.emailTemplatesAutoReplyHttpClient.assignedOffersList(id, searchParams);
  });

  constructor(
    private emailTemplatesAutoReplyHttpClient: EmailTemplatesAutoReplyHttpClient,
    private actions$: Actions,
  ) {}
}
